
import axiosInstance from '../utils/axiosConfig'
import { ACCOUNT_API_URL } from '../constant/apiUrls';


export const loginWithOuth = (queryParams) => {
  return axiosInstance.post(ACCOUNT_API_URL.login, queryParams)
}
export const IsReadedApi = (body) => {
  return axiosInstance
    .post(ACCOUNT_API_URL.isReadedApi, body)
}
export const EmployerSignup = (body) => {
  return axiosInstance.post(ACCOUNT_API_URL.employerSignup, body)
}
export const EmailPhoneValidate = (body) => {
  return axiosInstance.post(ACCOUNT_API_URL.emailPhoneValidate, body)
}
export const EnableSubscription = (body) => {
  return axiosInstance.post(ACCOUNT_API_URL.enableSubscription, body)
}
export const CompanyLogo = (body, _id) => {
  return axiosInstance.post(`${ACCOUNT_API_URL.companyLogo}`, body)
}

export const GovtDoc = (body, _id) => {
  return axiosInstance.post(`${ACCOUNT_API_URL.govtDoc}`, body)
}

export const ProfileImg = (body, _id) => {
  return axiosInstance.post(`${ACCOUNT_API_URL.ProfileImg}`, body)
}
export const GovtDocDelete = (id) => {
  return axiosInstance.delete(`${ACCOUNT_API_URL.govDocDelete}/${id}`)
}



export const EmployerProfile = () => {
  return axiosInstance.get(ACCOUNT_API_URL.employerProfile)
}

export const InvoiceList = () => {
  return axiosInstance.get(ACCOUNT_API_URL.employerInvoice)
}

export const sendOtp = (queryParams) => {
  return axiosInstance.post(ACCOUNT_API_URL.sendOtp, queryParams)
}

export const verifyOtp = (queryParams) => {
  return axiosInstance.post(ACCOUNT_API_URL.verifyOtp, queryParams)
}
export const employeeProfile = () => {
  return axiosInstance.get(ACCOUNT_API_URL.employeeProfile)
}

export const EmployeeProfileView = (id) => {
  return axiosInstance.get(ACCOUNT_API_URL.employeeProfileView,{
    params:{id}
  })
}
export const EmployeeView = (id) => {
  return axiosInstance.get(ACCOUNT_API_URL.employeeUserView,{
    params:{id}
  })
}

export const EmployerProfileView = (id) => {
  return axiosInstance.get(ACCOUNT_API_URL.employerView,{
    params:{id}
  })
}


export const Review = (id) => {
  return axiosInstance.get(ACCOUNT_API_URL.rating,{
    params:{id}
  })
}
export const RecentWork = (id) => {
  return axiosInstance.get(ACCOUNT_API_URL.recentWork,{
    params:{id}
  })
}

export const RecentLobPost = (id) => {
  return axiosInstance.get(ACCOUNT_API_URL.recentJobPost,{
    params:{id}
  })
}

export const employeeProfilesUpdate = (body) => {
  return axiosInstance.post(ACCOUNT_API_URL.employeeProfileUpdate, body)
}
export const employeeBankUpdate = (body) => {
  return axiosInstance.post(ACCOUNT_API_URL.employeeBankUpdate, body)
}
export const employeePhotosUpdate = (body, id) => {
  return axiosInstance.post(`${ACCOUNT_API_URL.employeePhotoUpdate}/${id}`, body)
}
export const employeeResumeUpdate = (body) => {
  return axiosInstance.post(ACCOUNT_API_URL.employeeResumeUpdate, body)
}
export const EmployeeDetails = (params) => {
  return axiosInstance.get(ACCOUNT_API_URL.employeeDetails,{params, responseType: 'blob',})
}
export const EmployeeSignup = (body) => {
  return axiosInstance.post(ACCOUNT_API_URL.employeeSignup, body)
}

export const EmployeeProfile = (body, id) => {
  return axiosInstance.post(`${ACCOUNT_API_URL.employeeProfile}/${id}`, body)
}

export const EmployeeSubscribe = () => {
  return axiosInstance.get(ACCOUNT_API_URL.employeeSubscription)
}
export const EmployeePaymentUpdate = (params, body) => {
  return axiosInstance.post(ACCOUNT_API_URL.employePayment, { payment_details: [body] }, { params, })
}
export const EmployerSubscriptionCreate = (body) => {
  return axiosInstance.post(ACCOUNT_API_URL.employerSubscription,body)
}
export const EmployerSubscriptionVerify = (body) => {
  return axiosInstance.post(ACCOUNT_API_URL.employerSubscriptionVerify, body)
}
export const EmployeeSubscriptionCreate = () => {
  return axiosInstance.get(ACCOUNT_API_URL.employeeSubscription)
}
export const EmployeeSubscriptionVerify = (body) => {
  return axiosInstance.post(ACCOUNT_API_URL.employeeSubscriptionVerify, body)
}

export const EmployeeTabData = (body) => {
  return axiosInstance.post(ACCOUNT_API_URL.employeeTabData, body)
}
export const EmployeeTabPrivateJob =  (params) => {
  return axiosInstance.get(ACCOUNT_API_URL.employeeTabPrivateJob, null, params)
}
export const EmployeeSubscriptionView = () => {
  return axiosInstance.get(ACCOUNT_API_URL.employeeSubscriptionView)
}
export const getEmployeeBankDetails = () => {
  return axiosInstance.get(ACCOUNT_API_URL.getEmployeeBankDetails)
}

export const EmployerSubscriptionView = () => {
  return axiosInstance.get(ACCOUNT_API_URL.employerSubscriptionView)
}
export const JobAplicationCreate = (body) => {
  return axiosInstance.post(ACCOUNT_API_URL.jobApplicationCreate, body)
}

export const CertificationAplicationCreate = (body) => {
  return axiosInstance.post(ACCOUNT_API_URL.certificationApplicationCreate, body)
}
export const CertificateApliedStatus = (id) => {
  return axiosInstance.get(`${ACCOUNT_API_URL.certificateStatus}/${id}`)
}


export const EmployeeSubscriptionRenewal = () => {
  return axiosInstance.get(ACCOUNT_API_URL.employeeRenewal)
}
export const EmployerSubscriptionRenewal = () => {
  return axiosInstance.get(ACCOUNT_API_URL.employerRenewal)
}

export const sendOtpEmployer = (queryParams) => {
  return axiosInstance.post(ACCOUNT_API_URL.sendOtpEmployer, queryParams)
}

export const sendMobileOtp = (queryParams) => {
  return axiosInstance.post(ACCOUNT_API_URL.sendMobileOtp, queryParams)
}

export const createPassword = (queryParams) => {
  return axiosInstance.post(ACCOUNT_API_URL.createPassword, queryParams)
}

export const verifyOtpEmployer = (queryParams) => {
  return axiosInstance.post(ACCOUNT_API_URL.verifyOtpEmployer, queryParams)
}
export const RequestsPassword = (body) => {
  return axiosInstance.post(ACCOUNT_API_URL.requestPassword, body)
}
export const NewPassword = (body) => {
  return axiosInstance.post(ACCOUNT_API_URL.setPassword, body)
}

export const sendEmailOtp = (body) => {
  return axiosInstance.post(ACCOUNT_API_URL.sendEmailOtp, body)
}
export const verifyEmailOtp = (body) => {
  return axiosInstance.post(ACCOUNT_API_URL.verifyEmailOtp, body)
}
export const NotificationsList = (body) => {
  return axiosInstance.post(ACCOUNT_API_URL.notificationsList, body)
}
export const EmployerNotificationsList = (body) => {
  return axiosInstance.post(ACCOUNT_API_URL.employerNotificationsList, body)
}

export const rejectionPayment = () => {
  return axiosInstance.post(ACCOUNT_API_URL.rejectionPayment)
}

export const rejectionPaymentCapture = (body) => {
  return axiosInstance.post(ACCOUNT_API_URL.rejectionPaymentCapture,body)
}
export const employeeComplaint = (body) => {
  return axiosInstance.post(ACCOUNT_API_URL.employeeComplaint, body)
}
export const employerComplaint = (body) => {
  return axiosInstance.post(ACCOUNT_API_URL.employerComplaint, body)
}


export const EmployerSubscriptioData = () => {
  return axiosInstance.get(ACCOUNT_API_URL.employerSubscriptioData)
}
export const certificatePhotosUpdate = (body, id) => {
  return axiosInstance.post(ACCOUNT_API_URL.certificatePhotosUpdate, body, { params: { id } });
}
export const employeeDeleteAccount = () => {
  return axiosInstance.post(ACCOUNT_API_URL.employeeDeleteAccount)
}
export const employerDeleteAccount = () => {
  return axiosInstance.post(ACCOUNT_API_URL.employerDeleteAccount)
}

export const GetEmployeeProfile = (_id) => {
  return axiosInstance
    .get(ACCOUNT_API_URL.employeeProfileGet)
}
export const EmployeeFileDownload = (params) => {
  return axiosInstance.get(ACCOUNT_API_URL.employeeDetailsDownload,{params, responseType: 'blob',})
}
